import localStore from "../LocalStore";
import { Client as apiClient } from "../GraphqlClient/GraphqlClient";

export const logout = async () => {
  localStore.clear();
  await apiClient.clearStore();
};
